import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import classnames from 'classnames';
import { defineMessages, useIntl } from 'dibs-react-intl';
import { ipfsGatewayLink } from 'dibs-crypto-utils/exports/formattingUtils';
import { Link } from 'dibs-elements/exports/Link';

import styles from './styles/NftItemTileTokenDetails.scss';
import { NftItemTileTokenDetails_nftItem$key } from './__generated__/NftItemTileTokenDetails_nftItem.graphql';

const messages = defineMessages({
    tokenId: { id: 'nftItemTile.tokenDetails.tokenId', defaultMessage: 'Token ID:' },
    tokenMetadata: {
        id: 'nftItemTile.tokenDetails.tokenMetadata',
        defaultMessage: 'Token Metadata:',
    },
    ipfs: { id: 'nftItemTile.tokenDetails.ipfs', defaultMessage: 'IPFS' },
    token: { id: 'nftItemTile.tokenDetails.token', defaultMessage: 'Token:' },
});

function getUriLabel(uri: string | null = null): string | null {
    if (!uri) {
        return null;
    } else if (/^ipfs/.test(uri)) {
        return 'IPFS';
    } else if (/^https?:\/\/arweave/.test(uri)) {
        return 'arweave';
    } else {
        return 'web';
    }
}

type Props = {
    nftItem: NftItemTileTokenDetails_nftItem$key;
    showToken?: boolean;
    inset?: boolean;
};

export const NftItemTileTokenDetails: FC<Props> = props => {
    const intl = useIntl();
    const nftItem = useFragment(
        graphql`
            fragment NftItemTileTokenDetails_nftItem on NftItem {
                tokenId
                tokenUri
                contract {
                    name
                }
            }
        `,
        props.nftItem
    );

    return (
        <dl className={classnames(styles.container, { [styles.inset]: props.inset })}>
            {props.showToken && <dt>{intl.formatMessage(messages.token)}</dt>}
            {props.showToken && <dd>{nftItem.contract?.name}</dd>}
            <dt>{intl.formatMessage(messages.tokenId)}</dt>
            <dd>{nftItem.tokenId}</dd>
            <dt>{intl.formatMessage(messages.tokenMetadata)}</dt>
            <dd>
                <Link href={ipfsGatewayLink(nftItem.tokenUri ?? '')} target="_blank">
                    {getUriLabel(nftItem.tokenUri)}
                </Link>
            </dd>
        </dl>
    );
};
